import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import { LoadModalWithLabel } from '../modais'
import {
  InputCustom,
  InputMaskCustom,
  SelectCustom,
  Loading,
  HttpError,
} from '../../components'
import * as ApiHelper from '../../ApiHelper'
import * as constants from '../../constants'
import Util from '../../Util'
import { ToastContainer, ToastMessage } from 'react-toastr'
import PrepostoModal from './PrepostoModal'

class ContratadosForm extends Component {
  constructor() {
    super()
    this.changeViewForTipo = this.changeViewForTipo.bind(this)
    this.addItem = this.addItem.bind(this)
    this.removeItem = this.removeItem.bind(this)
    this.getObject = this.getObject.bind(this)
    this.fillFields = this.fillFields.bind(this)
    this.onChangeNomeRazao = this.onChangeNomeRazao.bind(this)
    this.onChangeDocumento = this.onChangeDocumento.bind(this)
    this.onChangeTipo = this.onChangeTipo.bind(this)
    this.onChangeCEP = this.onChangeCEP.bind(this)
    this.onChangeTelefone = this.onChangeTelefone.bind(this)
    this.onKeyDownTelefone = this.onKeyDownTelefone.bind(this)
    this.onChangeNumero = this.onChangeNumero.bind(this)
    this.getAddessWithCEP = this.getAddessWithCEP.bind(this)
    this.onKeyPressCEP = this.onKeyPressCEP.bind(this)
    this.onChangeNomePreposto = this.onChangeNomePreposto.bind(this)
    this.onChangeCPFPreposto = this.onChangeCPFPreposto.bind(this)
    this.onChangeTelefonePreposto = this.onChangeTelefonePreposto.bind(this)
    this.onChangeEmailPreposto = this.onChangeEmailPreposto.bind(this)
    this.onKeyDownTelefonePreposto = this.onKeyDownTelefonePreposto.bind(this)
    this.sendForm = this.sendForm.bind(this)
    this.onChangeComplemento = this.onChangeComplemento.bind(this)
    this.handleErrors = this.handleErrors.bind(this)
    this.getUnidades = this.getUnidades.bind(this)
    this.onChangeUnidade = this.onChangeUnidade.bind(this)
    this.onChangeRua = this.onChangeRua.bind(this)
    this.onChangeBairro = this.onChangeBairro.bind(this)
    this.togglePrepostoModal = this.togglePrepostoModal.bind(this)
    this.reloadPreposto = this.reloadPreposto.bind(this)
    this.toggleLoadModal = this.toggleLoadModal.bind(this)
    this.state = {
      showLoad: false,
      editingItem: '',
      showPrepostoModal: false,
      showForm: false,
      unidades: [],
      unidadeOrcamentaria: '',
      tipo: 'Física',
      tipoNome: 'Nome',
      tipoDocumento: 'CPF',
      telefone: '',
      documento: '',
      nomeRazaoSocial: '',
      cep: '',
      currentPrepostos: [],
      showAddressFields: false,
      maskTelefone: '(99) 9999-9999',
      maskDocumento: '999.999.999-99',
      rua: '',
      bairro: '',
      cidade: '',
      estado: '',
      numero: '',
      complemento: '',
      prepostos: [
        {
          nome: '',
          cpf: '',
          telefone: '',
          email: undefined,
          maskTelefone: '(99) 9999-9999',
        },
      ],
      prepostosError: [
        {
          nome: '',
          cpf: '',
          telefone: '',
          email: '',
        },
      ],
      shouldDisableRua: 'disabled',
      shouldDisableBairro: 'disabled',
      cepFillError: false,
    }
    this.showSucessMessage = this.showSucessMessage.bind(this)
    this.toastFactory = React.createFactory(ToastMessage.animation)
  }
  toggleLoadModal() {
    this.setState({
      showLoad: !this.state.showLoad,
    })
  }
  showSucessMessage() {
    var message = ''
    var title = 'Sucesso'
    if (this.props.isEditing) {
      message = 'Contratado atualizado com sucesso'
    } else {
      message = 'Contratado cadastrado com sucesso'
    }
    this.container.success(title, message, {
      timeOut: 2000,
      extendedTimeOut: 3000,
    })
  }
  showErrorMessage() {
    this.container.error(
      'Ocorreram erros',
      'Verifique os dados e tente novamente',
      {
        timeOut: 2000,
        extendedTimeOut: 3000,
      }
    )
  }
  componentDidMount() {
    if (this.props.isEditing) {
      this.getObject()
    } else {
      this.getUnidades()
    }
  }

  getObject() {
    ApiHelper.getContratado(this.props.match.params.id, (data, error) => {
      if (data) {
        this.setState(
          {
            unidades: Util.mapUnidades(data.unidades),
          },
          () => {
            this.fillFields(data.contratado)
            window.scrollTo(0, 0)
          }
        )
      } else {
        this.setState({
          httpError: error,
        })
      }
    })
  }
  getUnidades() {
    ApiHelper.getUnidadesOrcametarias((unidadesJson, error) => {
      if (unidadesJson) {
        this.setState(
          {
            unidades: Util.mapUnidades(unidadesJson),
            showForm: true,
          },
          () => {
            window.scrollTo(0, 0)
          }
        )
      } else {
        this.setState({
          httpError: error,
        })
      }
    })
  }
  fillFields(fields) {
    this.changeViewForTipo(fields.tipo)
    var currentFields = {
      showAddressFields: true,
      nome_razao_socialLabel: fields.nome_razao_social,
      tipo: fields.tipo,
      telefone: fields.telefone,
      documento: fields.cpf_cnpj,
      nomeRazaoSocial: fields.nome_razao_social,
      cep: fields.cep,
      rua: fields.rua,
      bairro: fields.bairro,
      cidade: fields.cidade,
      estado: fields.estado,
      numero: fields.numero,
      complemento: fields.complemento,
      nomePreposto: fields.nome_responsavel,
      cpfPreposto: fields.cpf_responsavel,
      telefonePreposto: fields.telefone_responsavel,
      emailPreposto: fields.email_responsavel,
      unidadeOrcamentaria: fields.unidade_orcamentaria_id,
      currentPrepostos: fields.prepostos,
      showForm: true,
      prepostos: [],
      prepostosError: [],
    }
    this.setState(currentFields)
  }
  onChangeUnidade(event) {
    this.setState({ unidade_orcamentaria_idError: '', cpf_cnpjError: '' })
    var newValue = event.target.value
    this.setState({ unidadeOrcamentaria: newValue })
  }
  onChangeComplemento(event) {
    var newValue = event.target.value
    this.setState({ complemento: newValue })
  }
  onChangeTipo(event) {
    var tipo = event.target.value
    this.setState({ tipo: tipo })
    this.changeViewForTipo(tipo)
  }
  changeViewForTipo(tipo) {
    if (tipo === 'Física') {
      this.setState({
        tipoDocumento: 'CPF',
        tipoNome: 'Nome',
        nomeRazaoSocial: '',
        documento: '',
        maskDocumento: '999.999.999-99',
      })
    } else {
      this.setState({
        tipoDocumento: 'CNPJ',
        tipoNome: 'Razão Social',
        nomeRazaoSocial: '',
        documento: '',
        maskDocumento: '**.***.***/****-99',
      })
    }
  }
  //Requisição de CEP
  getAddessWithCEP(cep) {
    ApiHelper.getAdressWithCEP(cep, (addressObject) => {
      if (addressObject) {
        this.setState({
          rua: addressObject.rua || 'S/R',
          bairro: addressObject.bairro || 'S/B',
          cidade: addressObject.cidade || 'S/C',
          estado: addressObject.estado || 'S/E',
          shouldDisableRua:
            addressObject.rua === '' || addressObject.rua === undefined
              ? undefined
              : 'disabled',
          shouldDisableBairro:
            addressObject.bairro === '' || addressObject.bairro === undefined
              ? undefined
              : 'disabled',
          showAddressFields: true,
        })
      } else {
        this.setState({ cepError: true })
      }
    })
  }
  onChangeCEP(event) {
    this.setState({ cepError: '' })
    var newValue = event.target.value
    this.setState({ cepError: false, cep: newValue }, () => {
      var unmaskedCep = Util.unmaskField(this.state.cep) || ''
      if (unmaskedCep.length === 8) {
        this.getAddessWithCEP(unmaskedCep)
      } else {
        this.setState({ showAddressFields: false })
      }
    })
  }
  onKeyPressCEP(event) {
    var keyPressed = event.key
    var unmaskedCep = Util.unmaskField(this.state.cep)
    if (unmaskedCep.length === 7 && !isNaN(event.key)) {
      this.getAddessWithCEP(unmaskedCep + keyPressed)
    } else if (unmaskedCep.length !== 8) {
      this.setState({ showAddressFields: false })
    }
  }
  //Modal de itens de contrato
  togglePrepostoModal(event, index, itemID) {
    this.setState({
      editingItem: itemID,
      showPrepostoModal: !this.state.showPrepostoModal,
    })
  }
  onChangeNomeRazao(event) {
    this.setState({ nome_razao_socialError: '' })
    var newValue = event.target.value
    this.setState({ nomeRazaoSocial: newValue })
  }
  onChangeDocumento(event) {
    this.setState({ cpf_cnpjError: '' })
    var newValue = event.target.value
    this.setState({ documento: newValue })
  }
  //Mascara de telefone
  onChangeTelefone(event) {
    this.setState({ telefoneError: '' })
    var newValue = event.target.value
    this.setState({ telefone: newValue })
  }

  onKeyDownTelefone(event) {
    var keyPressed = event.key
    var unmaskedField = Util.unmaskField(this.state.telefone)
    if (unmaskedField.length === 10 && !isNaN(keyPressed)) {
      this.setState({
        telefone: this.state.telefone + keyPressed,
        maskTelefone: '(99) 99999-9999',
      })
    } else if (unmaskedField.length === 11 && event.keyCode === 8) {
      this.setState({ maskTelefone: '(99) 9999-9999' })
    }
  }
  //Mascara de telefone
  onChangeNumero(event) {
    this.setState({ numeroError: '' })
    var newValue = event.target.value
    this.setState({ numero: newValue })
  }
  onChangeRua(event) {
    this.setState({ ruaError: '' })
    var newValue = event.target.value
    this.setState({ rua: newValue })
  }
  onChangeBairro(event) {
    this.setState({ bairroError: '' })
    var newValue = event.target.value
    this.setState({ bairro: newValue })
  }
  onChangeNomePreposto(event, key) {
    var oldPrepostosError = this.state.prepostosError
    oldPrepostosError[key].nome = ''
    this.setState({ prepostosError: oldPrepostosError })

    var oldPrepostos = this.state.prepostos
    var newValue = event.target.value
    oldPrepostos[key].nome = newValue
    this.setState({ prepostos: oldPrepostos })
  }
  onChangeCPFPreposto(event, key) {
    var oldPrepostosError = this.state.prepostosError
    oldPrepostosError[key].cpf = ''
    this.setState({ prepostosError: oldPrepostosError })

    var oldPrepostos = this.state.prepostos
    var newValue = event.target.value
    oldPrepostos[key].cpf = newValue
    this.setState({ prepostos: oldPrepostos })
  }
  onChangeTelefonePreposto(event, key) {
    var oldPrepostosError = this.state.prepostosError
    oldPrepostosError[key].telefone = ''
    this.setState({ prepostosError: oldPrepostosError })

    var oldPrepostos = this.state.prepostos
    var newValue = event.target.value
    oldPrepostos[key].telefone = newValue
    this.setState({ prepostos: oldPrepostos })
  }
  onKeyDownTelefonePreposto(event, key) {
    var keyPressed = event.key
    var oldPrepostos = this.state.prepostos
    var telefone = oldPrepostos[key].telefone
    var unmaskedField = Util.unmaskField(telefone)
    if (unmaskedField.length === 10 && !isNaN(keyPressed)) {
      oldPrepostos[key].telefone += keyPressed
      oldPrepostos[key].maskTelefone = '(99) 99999-9999'
    } else if (unmaskedField.length === 11 && event.keyCode === 8) {
      oldPrepostos[key].maskTelefone = '(99) 9999-9999'
    }
    this.setState({
      prepostos: oldPrepostos,
    })
  }
  onChangeEmailPreposto(event, key) {
    var oldPrepostosError = this.state.prepostosError
    oldPrepostosError[key].email = ''
    this.setState({ prepostosError: oldPrepostosError })

    var oldPrepostos = this.state.prepostos
    var newValue = event.target.value
    oldPrepostos[key].email = newValue
    this.setState({ prepostos: oldPrepostos })
  }
  sendForm(event) {
    event.preventDefault()
    var prespostosToSend = this.state.prepostos.map((preposto) => {
      return {
        nome: preposto.nome,
        cpf: Util.unmaskField(preposto.cpf),
        telefone: Util.unmaskField(preposto.telefone),
        email: preposto.email,
      }
    })
    var parameters = {
      nome_razao_social: this.state.nomeRazaoSocial,
      cpf_cnpj: Util.normalizeCnpjAlfanumerico(this.state.documento),
      telefone: Util.unmaskField(this.state.telefone),
      rua: this.state.rua,
      bairro: this.state.bairro,
      cidade: this.state.cidade,
      estado: this.state.estado,
      numero: this.state.numero,
      tipo: this.state.tipo,
      complemento: this.state.complemento,
      telefone_responsavel: Util.unmaskField(this.state.telefonePreposto),
      cpf_responsavel: Util.unmaskField(this.state.cpfPreposto),
      nome_responsavel: this.state.nomePreposto,
      email_responsavel: this.state.emailPreposto,
      unidade_orcamentaria_id: this.state.unidadeOrcamentaria,
      cep: Util.unmaskField(this.state.cep),
      prepostos: prespostosToSend,
    }
    this.toggleLoadModal()
    if (this.props.isEditing) {
      ApiHelper.updateContratado(
        parameters,
        this.props.match.params.id,
        (error) => {
          this.toggleLoadModal()
          if (error) {
            this.showErrorMessage()
            this.handleErrors(error)
          } else {
            this.showSucessMessage()
            Util.sleep(3000).then(() => {
              this.props.callBackContratados()
            })
          }
        }
      )
    } else {
      ApiHelper.createNewContratado(parameters, (error) => {
        this.toggleLoadModal()
        if (error) {
          this.showErrorMessage()
          this.handleErrors(error)
        } else {
          this.showSucessMessage()
          Util.sleep(3000).then(() => {
            this.props.callBackContratados()
          })
        }
      })
    }
  }
  handleErrors(errors) {
    var errorsJSON = JSON.parse(errors)
    var errorsValue = errorsJSON.errors
    var errorsState = {}
    var prepostosError = []
    this.state.prepostos.forEach(() => {
      prepostosError.push({
        nome: '',
        cpf: '',
        telefone: '',
        email: '',
      })
    })
    for (var key in errorsValue) {
      if (key.includes('prepostos.')) {
        var index = key.split('prepostos.').join('')
        if (index.includes('.nome')) {
          index = index.split('.nome').join('')
          prepostosError[index].nome = errorsValue[key][0]
        }
        if (index.includes('.cpf')) {
          index = index.split('.cpf').join('')
          prepostosError[index].cpf = errorsValue[key][0]
        }
        if (index.includes('.telefone')) {
          index = index.split('.telefone').join('')
          prepostosError[index].telefone = errorsValue[key][0]
        }
        if (index.includes('.email')) {
          index = index.split('.email').join('')
          prepostosError[index].email = errorsValue[key][0]
        }
      } else {
        errorsState[key + 'Error'] = errorsValue[key][0]
      }
    }
    errorsState.prepostosError = prepostosError
    this.setState(errorsState)
  }
  addItem() {
    var oldPrespostos = this.state.prepostos
    var oldPrespostosError = this.state.prepostosError
    oldPrespostosError.push({
      nome: '',
      cpf: '',
      telefone: '',
      email: '',
    })
    oldPrespostos.push({
      nome: '',
      cpf: '',
      telefone: '',
      email: undefined,
      maskTelefone: '(99) 9999-9999',
    })
    this.setState({
      prepostos: oldPrespostos,
      prepostosError: oldPrespostosError,
    })
  }
  removeItem(index) {
    var oldPrespostos = this.state.prepostos
    var oldPrespostosError = this.state.prepostosError

    oldPrespostos.splice(index, 1)
    oldPrespostosError.splice(index, 1)

    this.setState({
      prepostos: oldPrespostos,
      prepostosError: oldPrespostosError,
    })
  }
  removeCurrentPreposto(event, index, item) {
    ApiHelper.deletePreposto(item, (error) => {
      if (error) {
        this.addAlert('', error.message)
      } else {
        var currentItens = this.state.currentPrepostos
        currentItens.splice(index, 1)
        this.setState({
          currentPrepostos: currentItens,
        })
      }
    })
  }
  reloadPreposto(newPreposto) {
    var oldCurrentPrepostos = this.state.currentPrepostos
    oldCurrentPrepostos.forEach((preposto, key) => {
      if (preposto.id === newPreposto.id) {
        oldCurrentPrepostos[key] = newPreposto
      }
    })
    this.togglePrepostoModal()
  }
  render() {
    var tipos = [
      { value: 'Física', label: 'Física' },
      { value: 'Jurídica', label: 'Jurídica' },
    ]
    if (this.state.httpError) {
      return (
        <div className="container-fluid">
          <HttpError
            message={this.state.httpError.message}
            status={this.state.httpError.status}
          />
        </div>
      )
    }
    return (
      <div className="container-fluid">
        <LoadModalWithLabel
          label="Aguarde..."
          onClose={this.toggleLoadModal}
          show={this.state.showLoad}
        />
        <PrepostoModal
          callBack={this.reloadPreposto}
          prepostoId={this.state.editingItem}
          show={this.state.showPrepostoModal}
          onClose={this.togglePrepostoModal}
        />
        <div>
          {this.state.showForm === false && <Loading />}
          {this.state.showForm === true && (
            <div className="card card-plain">
              <ToastContainer
                ref={(input) => {
                  this.container = input
                }}
                toastMessageFactory={this.toastFactory}
                className="toast-top-right"
                preventDuplicates={true}
              />
              <div className="card-header" data-background-color="as-blue">
                <h4 className="title">
                  {this.props.isEditing
                    ? 'Editar Contratado'
                    : 'Criar contratado'}
                </h4>
                <p className="category">
                  {this.props.isEditing
                    ? 'Contratado : ' + this.state.nome_razao_socialLabel
                    : 'Criar novo fornecedor'}
                </p>
              </div>

              <div className="card-content">
                <form>
                  <div className="row">
                    <SelectCustom
                      sizeClass="col-md-4"
                      options={tipos}
                      label="Tipo"
                      value={this.state.tipo}
                      onChange={this.onChangeTipo}
                    />
                  </div>
                  <div className="row">
                    <InputCustom
                      error={this.state.nome_razao_socialError}
                      sizeClass="col-md-4"
                      label={this.state.tipoNome}
                      type="text"
                      onChange={this.onChangeNomeRazao}
                      value={this.state.nomeRazaoSocial}
                    />
                    <InputMaskCustom
                      error={this.state.cpf_cnpjError}
                      mask={this.state.maskDocumento}
                      sizeClass="col-md-4"
                      label={this.state.tipoDocumento}
                      type="text"
                      onChange={this.onChangeDocumento}
                      value={this.state.documento}
                    />
                    <InputMaskCustom
                      error={this.state.telefoneError}
                      onKeyDown={this.onKeyDownTelefone}
                      mask={this.state.maskTelefone}
                      sizeClass="col-md-4"
                      label="Telefone"
                      type="text"
                      onChange={this.onChangeTelefone}
                      value={this.state.telefone}
                    />
                  </div>
                  <div className="row">
                    <SelectCustom
                      error={this.state.unidade_orcamentaria_idError}
                      sizeClass="col-md-3"
                      options={this.state.unidades}
                      label="Unidade orçamentária"
                      name={'unidades'}
                      onChange={this.onChangeUnidade}
                      value={this.state.unidadeOrcamentaria}
                    />
                    {constants.haveRole(1) && (
                      <div>
                        <br />
                        <button
                          onClick={this.toggleUnidadesModal}
                          style={{ width: '4%' }}
                          type="button"
                          rel="tooltip"
                          title="Criar contratado"
                          className="btn btn-success btn-simple btn-xs col-md-1">
                          <i
                            className="icon-header material-icons"
                            style={{ fontSize: 20 }}>
                            control_point
                          </i>
                        </button>
                      </div>
                    )}
                  </div>
                  <div className="row">
                    <InputMaskCustom
                      onPaste={this.onPasteCEP}
                      error={this.state.cepError}
                      mask="99999-999"
                      sizeClass="col-md-4"
                      onKeyDown={this.onKeyPressCEP}
                      onChange={this.onChangeCEP}
                      value={this.state.cep}
                      label="CEP"
                      type="text"
                    />
                  </div>
                  {this.state.cepFillError === true && (
                    <div className="row">
                      <div className="col-md-4">
                        <div className="alert alert-danger">CEP Inválido</div>
                      </div>
                    </div>
                  )}
                  {this.state.showAddressFields === true && (
                    <div>
                      <div className="row">
                        <InputCustom
                          onChange={this.onChangeRua}
                          error={this.state.ruaError}
                          sizeClass="col-md-4"
                          label={'Rua'}
                          disabled={this.state.shouldDisableRua}
                          type="text"
                          value={this.state.rua}
                        />
                        <InputCustom
                          error={this.state.numeroError}
                          sizeClass="col-md-1"
                          label={'Numero'}
                          type="text"
                          onChange={this.onChangeNumero}
                          value={this.state.numero}
                        />
                        <InputCustom
                          onChange={this.onChangeBairro}
                          error={this.state.bairroError}
                          sizeClass="col-md-3"
                          label={'Bairro'}
                          disabled={this.state.shouldDisableBairro}
                          type="text"
                          value={this.state.bairro}
                        />
                        <InputCustom
                          error={this.state.cidadeError}
                          sizeClass="col-md-3"
                          label="Cidade"
                          disabled={
                            this.state.cidade === 'S/C' ? undefined : 'disabled'
                          }
                          type="text"
                          value={this.state.cidade}
                        />
                        <InputCustom
                          error={this.state.estadoError}
                          sizeClass="col-md-1"
                          label="Estado"
                          disabled={
                            this.state.estado === 'S/E' ? undefined : 'disabled'
                          }
                          type="text"
                          value={this.state.estado}
                        />
                      </div>
                      <div className="row">
                        <InputCustom
                          sizeClass="col-md-12"
                          label={'Complemento'}
                          type="text"
                          onChange={this.onChangeComplemento}
                          value={this.state.complemento}
                        />
                      </div>
                    </div>
                  )}

                  <div className="card" data-background-color="light-blue">
                    <div
                      className="card-header"
                      data-background-color="as-blue">
                      <h4 className="title">Dados dos prepostos</h4>
                      <p className="category">
                        Contato e documentos dos responsáveis pela empresa
                      </p>
                    </div>
                    <div className="card-content">
                      {this.state.currentPrepostos.map((preposto, key) => {
                        return (
                          <div>
                            <div key={key} className="row">
                              <InputCustom
                                disabled="disabled"
                                sizeClass="col-md-4"
                                label="Nome"
                                type="text"
                                value={preposto.nome}
                              />
                              <InputMaskCustom
                                disabled="disabled"
                                mask="999.999.999-99"
                                sizeClass="col-md-2"
                                label="CPF"
                                type="text"
                                value={preposto.cpf}
                              />
                              <InputMaskCustom
                                disabled="disabled"
                                mask={preposto.maskTelefone}
                                sizeClass="col-md-2"
                                label="Telefone"
                                type="text"
                                value={preposto.telefone}
                              />
                              <InputCustom
                                disabled="disabled"
                                sizeClass="col-md-4"
                                label="Email"
                                type="text"
                                value={
                                  preposto.email === null
                                    ? undefined
                                    : preposto.email
                                }
                              />
                            </div>
                            <div className="row">
                              <button
                                type="button"
                                title="Remover item"
                                onClick={(event) =>
                                  this.removeCurrentPreposto(
                                    event,
                                    key,
                                    preposto.id
                                  )
                                }
                                className="btn btn-danger pull-left"
                                data-background-color="red">
                                <i className="icon-header material-icons">
                                  delete
                                </i>
                              </button>
                              <button
                                type="button"
                                title="Editar item"
                                onClick={(event) =>
                                  this.togglePrepostoModal(
                                    event,
                                    key,
                                    preposto.id
                                  )
                                }
                                className="btn btn-danger pull-left"
                                data-background-color="blue">
                                <i className="icon-header material-icons">
                                  create
                                </i>
                              </button>
                            </div>
                          </div>
                        )
                      })}
                      {this.state.prepostos.map((preposto, key) => {
                        return (
                          <div key={key}>
                            <div className="row">
                              <InputCustom
                                error={this.state.prepostosError[key].nome}
                                sizeClass="col-md-4"
                                label="Nome"
                                type="text"
                                onChange={(event) =>
                                  this.onChangeNomePreposto(event, key)
                                }
                                value={preposto.nome}
                              />
                              <InputMaskCustom
                                error={this.state.prepostosError[key].cpf}
                                mask="999.999.999-99"
                                sizeClass="col-md-2"
                                label="CPF"
                                type="text"
                                onChange={(event) =>
                                  this.onChangeCPFPreposto(event, key)
                                }
                                value={preposto.cpf}
                              />
                              <InputMaskCustom
                                error={this.state.prepostosError[key].telefone}
                                onKeyDown={(event) =>
                                  this.onKeyDownTelefonePreposto(event, key)
                                }
                                mask={preposto.maskTelefone}
                                sizeClass="col-md-2"
                                label="Telefone"
                                type="text"
                                onChange={(event) =>
                                  this.onChangeTelefonePreposto(event, key)
                                }
                                value={preposto.telefone}
                              />
                              <InputCustom
                                error={this.state.prepostosError[key].email}
                                sizeClass="col-md-4"
                                label="Email"
                                type="text"
                                onChange={(event) =>
                                  this.onChangeEmailPreposto(event, key)
                                }
                                value={preposto.email}
                              />
                            </div>

                            <div className="row">
                              <button
                                type="button"
                                onClick={() => this.removeItem(key)}
                                className="btn btn-danger pull-right"
                                data-background-color="red">
                                <i className="icon-header material-icons">
                                  delete
                                </i>
                              </button>
                            </div>
                          </div>
                        )
                      })}
                    </div>
                    <button
                      type="button"
                      onClick={this.addItem}
                      className="btn btn-primary pull-right"
                      data-background-color="green">
                      <i className="icon-header material-icons">add</i>
                    </button>
                  </div>
                  <button
                    onClick={this.sendForm}
                    type="submit"
                    className="btn btn-primary pull-left"
                    data-background-color="as-blue">
                    {this.props.isEditing ? 'Salvar' : 'Criar'}
                  </button>
                  <div className="clearfix" />
                </form>
              </div>
            </div>
          )}
        </div>
      </div>
    )
  }
}
export default withRouter(ContratadosForm)



// WEBPACK FOOTER //
// ./src/views/modais/ContratadosForm.js